import { ErrorIcons, Typogaphy } from 'vnetwork-ui'

interface NotificationInformationProps {
    title: string
}

const NotificationInformation = ({ title }: NotificationInformationProps) => {
    return (
        <div className="flex w-full ps-2 pe-4 py-4 bg-[#F9FBFF] rounded-sm gap-2">
            <ErrorIcons className="!min-w-4 w-4 h-4 text-primary" />
            <Typogaphy className="text-primary text-justify">{title}</Typogaphy>
        </div>
    )
}

export default NotificationInformation
